﻿import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    component: () => import('../views/Login.vue'),
    meta: { title: '管理员登录', public: true }
  },
  {
    path: '/handout/:id(\\d+)',
    component: () => import('../views/handout/Detail.vue'),
    meta: { title: '讲义编辑' }
  },
  {
    path: '/handout/:id(\\d+)/preview',
    component: () => import('../views/handout/Preview.vue'),
    meta: { title: '讲义预览' }
  },
  {
    path: '/handout/:id(\\d+)/pick-questions',
    component: () => import('../views/handout/QuestionPicker.vue'),
    meta: { title: '从题库添加题目' }
  },
  {
    path: '/teacher/handout/:id(\\d+)',
    component: () => import('../views/handout/Detail.vue'),
    meta: { title: '讲义编辑', teacherMode: true }
  },
  {
    path: '/teacher/handout/:id(\\d+)/preview',
    component: () => import('../views/handout/Preview.vue'),
    meta: { title: '讲义预览', teacherMode: true }
  },
  {
    path: '/teacher/handout/:id(\\d+)/pick-questions',
    component: () => import('../views/handout/QuestionPicker.vue'),
    meta: { title: '从题库添加题目', teacherMode: true }
  },
  {
    path: '/',
    component: () => import('../layout/Layout.vue'),
    redirect: '/question/list',
    children: [
      {
        path: 'question/list',
        component: () => import('../views/question/List.vue'),
        meta: { title: '题库管理' }
      },
      {
        path: 'paper/list',
        component: () => import('../views/paper/List.vue'),
        meta: { title: '试卷管理' }
      },
      {
        path: 'paper/:id',
        component: () => import('../views/paper/Detail.vue'),
        meta: { title: '试卷详情' }
      },
      {
        path: 'handout/list',
        component: () => import('../views/handout/List.vue'),
        meta: { title: '讲义管理' }
      },
      {
        path: 'member/list',
        component: () => import('../views/member/List.vue'),
        meta: { title: '会员管理' }
      },
      {
        path: 'order/list',
        component: () => import('../views/order/List.vue'),
        meta: { title: '订单管理' }
      },
      {
        path: 'wrong/list',
        component: () => import('../views/wrong/List.vue'),
        meta: { title: '错题管理' }
      },
      {
        path: 'feedback/list',
        component: () => import('../views/feedback/List.vue'),
        meta: { title: '问题反馈', role: 'ADMIN' }
      },
      {
        path: 'teacher/classes',
        component: () => import('../views/teacher/ClassManage.vue'),
        meta: { title: '教师工作台 · 分班与学情' }
      },
      {
        path: 'teacher/papers',
        component: () => import('../views/teacher/PaperList.vue'),
        meta: { title: '试卷管理（本学科）', teacherMode: true }
      },
      {
        path: 'teacher/papers/:id',
        component: () => import('../views/teacher/PaperDetail.vue'),
        meta: { title: '试卷题目' }
      },
      {
        path: 'teacher/questions',
        component: () => import('../views/question/List.vue'),
        meta: { title: '题库管理（本学科）', teacherMode: true }
      },
      {
        path: 'teacher/feedback',
        component: () => import('../views/teacher/Feedback.vue'),
        meta: { title: '问题反馈', teacherMode: true }
      },
      {
        path: 'teacher/handouts',
        component: () => import('../views/handout/List.vue'),
        meta: { title: '讲义管理（本学科）', teacherMode: true }
      },
      {
        path: 'teacher/wrong/list',
        component: () => import('../views/teacher/WrongList.vue'),
        meta: { title: '错题管理', teacherMode: true }
      },
      {
        path: 'system/admin',
        component: () => import('../views/system/Admin.vue'),
        meta: { title: '管理员管理', role: 'ADMIN' }
      },
      {
        path: 'system/basedata',
        component: () => import('../views/system/BaseData.vue'),
        meta: { title: '基础数据管理', role: 'ADMIN' }
      },
      {
        path: 'system/export-billing',
        component: () => import('../views/system/ExportBilling.vue'),
        meta: { title: '导出计费设置', role: 'ADMIN' }
      }
    ]
  },
  { path: '*', redirect: '/' }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

// 路由守卫：未登录则跳转到登录页；教师账号仅能访问教师工作台
router.beforeEach((to, from, next) => {
  document.title = (to.meta.title || '管理后台') + ' - 刷题系统'
  const token = localStorage.getItem('admin_token')
  if (!to.meta.public && !token) {
    next('/login')
    return
  }
  let role = 'ADMIN'
  try {
    role = JSON.parse(localStorage.getItem('admin_info') || '{}').role || 'ADMIN'
  } catch (e) {
    role = 'ADMIN'
  }
  if (role === 'TEACHER' && !to.meta.public && !to.path.startsWith('/teacher')) {
    next('/teacher/classes')
    return
  }
  if (to.meta && to.meta.role === 'ADMIN' && role !== 'ADMIN') {
    next('/teacher/classes')
    return
  }
  next()
})

export default router

